<template>
  <div class="answer">
    <p class="answer-type">参考答案：<span v-html="answer"></span></p>
    <p class="answer-type">深入解析：</p>
    <p class="answer-detail" v-html="data.answerName"></p>
  </div>
</template>

<script>
  export default {
    name: 'answer',
    props: {
      data: Object,
    },
    computed: {
      choices() {
        return [1, 2, 4, 12, 13].indexOf(this.data.questionOptionType) !== -1;
      },
      judge() {
        return this.data.questionOptionType === 3;
      },
      answer() {
        let result = '';
        if (this.choices) {
          this.data.answer.split('|').forEach((value) => {
            result += ['A', 'B', 'C', 'D', 'E', 'F'][value - 1];
          });
        } else if (this.judge) {
          result = +this.data.answer === 1 ? '正确' : '错误';
        } else {
          result = this.data.answer;
        }
        return result;
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.answer-type {
  font-size: 12px;
  color: $theme-color;
  line-height: 26px;
}

.answer-detail {
  font-size: 14px;
  color: #666;
  line-height: 21px;
}
</style>
